<template>
  <div
    class="inline-flex w-36 bg-white rounded-lg hover:bg-gray-100 focus:outline-none py-2 px-2"
    tabindex="0"
    @click="updateActivePlan"
    @keydown.space="updateActivePlan"
  >
    <div class="flex items-center px-2">
      <div v-if="this.activeOption === this.id">✅</div>
      <div v-else>⬜️</div>
      <p class="pl-3 text-gray-800">{{ this.optionName }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  model: {
    prop: 'activeOption',
    event: 'onUpdatePlan'
  },
  props: ['optionName', 'activeOption', 'id'],
  methods: {
    updateActivePlan() {
      this.$emit('onUpdatePlan', this.id)
    }
  }
}
</script>
